// Bundle plugin module
import Plugin from './Plugin';

export default {
	version: () => {
		return NSContext.plugins.cookies.version;
	}
	/*addScript: ( scriptId ) => {
		Plugin.addScript(scriptId);
	}*/
};

document.addEventListener('DOMContentLoaded', function () {
	const banner = document.querySelector('#nswow-cookie-banner');

	if(banner != null && banner.classList.contains("_advanced")){
		Plugin.initAdvanced();
	}else{
		Plugin.initSimple();
	}

});
